import { Link } from "react-router-dom";
import { FaUserNurse, FaHospital } from "react-icons/fa";

function AudienceSection() {
  return (
    <section
      className="audience-section"
      id="professionals"
    >
      <div className="audience-container">

        <div className="audience-card audience-professional">
          <div className="audience-icon">
            <FaUserNurse />
          </div>

          <h2>
               Healthcare
            <br />
               Professionals
          </h2>

          <p>
            Join Zeth Health to discover flexible assignments,
            manage your credentials and build your career across Canada.
          </p>

          <div className="audience-buttons">
            <Link
              className="primary-button"
              to="/professional/register"
            >
              Create Account
            </Link>

            <Link
              className="secondary-button"
              to="/professional/login"
            >
              Sign In
            </Link>
          </div>
        </div>

        <div
          className="audience-card"
          id="facilities"
        >
          <div className="audience-icon">
            <FaHospital />
          </div>

          <h2>
              Healthcare
            <br />
             Facilities
          </h2>

          <p>
            Request qualified healthcare professionals,
            fill staffing gaps quickly and manage workforce needs
            from one secure platform.
          </p>

          <div className="audience-buttons">
            <Link
              className="primary-button"
              to="/facility/register"
            >
              Register Facility
            </Link>

            <Link
              className="secondary-button"
              to="/facility/login"
            >
              Facility Login
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
}

export default AudienceSection;